export default "__VITE_ASSET__dgslrdZj__"